import { render, staticRenderFns } from "./CreateCampaignSourceInventory.vue?vue&type=template&id=07aed2de&scoped=true"
import script from "./CreateCampaignSourceInventory.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSourceInventory.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignSourceInventory.vue?vue&type=style&index=0&id=07aed2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aed2de",
  null
  
)

export default component.exports